import { render, staticRenderFns } from "./zyrsbd.vue?vue&type=template&id=2910fdfe&scoped=true"
import script from "./zyrsbd.vue?vue&type=script&lang=js"
export * from "./zyrsbd.vue?vue&type=script&lang=js"
import style0 from "./zyrsbd.vue?vue&type=style&index=0&id=2910fdfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2910fdfe",
  null
  
)

export default component.exports